/**
 * @fileoverview GET handler for the "/:app_group_id/liquid_validation/features" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdLiquidValidationFeatures } from "./constants";
import type { GetAppGroupIdLiquidValidationFeaturesResult, LiquidFeaturesVariant } from "./types";
import { isGetAppGroupIdLiquidValidationFeaturesResult } from "./validators";

export const getAppGroupIdLiquidValidationFeatures = reactQueryFetcherAdapter(
  appGroupIdLiquidValidationFeatures,
  (
    signal: AbortSignal,
    appGroupId: string,
    variant: LiquidFeaturesVariant
  ): Promise<GetAppGroupIdLiquidValidationFeaturesResult> => {
    return fetch(`/${appGroupId}/liquid_validation/features?variant=${variant}`, "GET", {}, { signal });
  },
  isGetAppGroupIdLiquidValidationFeaturesResult
);
